import script from "./CourseDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseDetail.vue?vue&type=script&setup=true&lang=ts"

import "./CourseDetail.vue?vue&type=style&index=0&id=68d0cc08&lang=scss"

const __exports__ = script;

export default __exports__